module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkbox-wrapper",
    on: {
      "click": function($event) {
        return _vm.handleCheckElement()
      }
    }
  }, [_c('div', {
    staticClass: "cbx"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.is_checked),
      expression: "is_checked"
    }],
    attrs: {
      "id": "cbx-12",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.is_checked) ? _vm._i(_vm.is_checked, null) > -1 : (_vm.is_checked)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.is_checked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.is_checked = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.is_checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.is_checked = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "cbx-12"
    }
  }), _vm._v(" "), _c('svg', {
    attrs: {
      "width": "14",
      "height": "14",
      "viewbox": "0 0 10 10",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M2 8.36364L6.23077 12L13 2"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-7a35be90!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/modals/New_RoundTable/Components/Checkbox.vue
// module id = 931
// module chunks = 61